import { parseDate, formatDateTime, formatTime, formatDate } from '../util/util';

export interface TimeSeriesPoint {
  datetime: Date;
  value: number;
}

export function parseServerTimeSeries(
  data: Array<{ datetime: string; value: number }> | undefined | null
): TimeSeriesPoint[] {
  if (data) {
    return data.map((e) => ({ ...e, datetime: parseDate(e.datetime)! }));
  }
  return [];
}

interface TimeSeries {
  name: string;
  series: TimeSeriesPoint[];
}
export function displayTimeSeries(
  series: TimeSeries[],
  { format }: { format?: 'time' | 'date' | 'datetime' } = {}
): Array<{ name: string }> {
  if (series.length === 0) {
    return [];
  }
  const byTimestamp: Record<string, Record<string, number>> = {};
  series.forEach((e, i) => {
    byTimestamp[i] = byTimestamp[i] || {};
    e.series.forEach((point) => (byTimestamp[i][point.datetime.getTime().toString()] = point.value));
  });
  const timestamps = Array.from(new Set(series.flatMap((e) => e.series.map((f) => f.datetime.getTime())))).sort(
    (a, b) => a - b
  );

  const formatFunction =
    format === undefined || format === 'datetime' ? formatDateTime : format === 'date' ? formatDate : formatTime;

  return timestamps.map((timestamp) => {
    const obj = {
      name: formatFunction(new Date(timestamp)) ?? '',
    };
    series.forEach((e, i) => (obj[e.name] = byTimestamp[i][timestamp] ?? 0));
    return obj;
  });
}
